/** @module Free text fields that offer earlier entries and presets: where bought, notes. */
import { useTranslation } from "react-i18next";

import { ComboInput } from "@/components/ui/combo-input";
import { useSuggestions } from "@/lib/suggestions";

function presets(value: unknown): string[] {
  return Array.isArray(value) ? value.filter((one): one is string => typeof one === "string") : [];
}

/** "Gekauft bei": the user's own shops first, then the usual ones. */
export function SourceInput({
  value,
  onChange,
  label,
}: {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}) {
  const { t } = useTranslation();
  const used = useSuggestions();
  return (
    <ComboInput
      label={label ?? t("purchase.source")}
      value={value}
      onChange={onChange}
      maxLength={80}
      placeholder={t("purchase.sourcePlaceholder")}
      groups={[
        { label: t("suggest.recent"), options: used.data?.purchase_source ?? [] },
        {
          label: t("suggest.presets"),
          options: presets(t("purchase.sources", { returnObjects: true })),
        },
      ]}
    />
  );
}

/** A note on one copy: earlier notes and the usual remarks ("Signiert", "Fehldruck" …). */
export function NoteInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation();
  const used = useSuggestions();
  return (
    <ComboInput
      label={t("collection.note")}
      value={value}
      onChange={onChange}
      maxLength={500}
      placeholder={t("suggest.notePlaceholder")}
      groups={[
        { label: t("suggest.recent"), options: used.data?.note ?? [] },
        {
          label: t("suggest.presets"),
          options: presets(t("suggest.notes", { returnObjects: true })),
        },
      ]}
    />
  );
}
